import React from "react";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Tooltip from "@mui/material/Tooltip";
import QuestionIcon from "@mui/icons-material/HelpOutline";

const ReportsSummaryTable = ({
  contractsAmount,
  receiptsAmount,
  withdrawsAmount,
  expensesAmount,
  currentEducationYear,
}) => {
  return (
    <div>
      <h4>GENEL MUHASEBE RAPORU</h4>
      <TableContainer component={Paper} sx={{ minWidth: 650, width: "inherit" }}>
        <Table
          sx={{ minWidth: 650, width: "100%", justifyContent: "center", margin: "auto" }}
          stickyHeader
          aria-label="simple table"
        >
          <TableHead>
            <TableRow>
              <TableCell>
                <div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                  <b>YILLIK ALACAK</b>
                  <Tooltip
                    title={currentEducationYear.name + " eğitim yılı için öğrenci sözleşmelerinin toplam tutarı"}
                  >
                    <QuestionIcon sx={{ marginLeft: "5px", color: "gray", width: "20px", height: "auto" }} />
                  </Tooltip>
                </div>
              </TableCell>
              <TableCell>
                <div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                  <b>TOPLAM TAHSİLAT</b>
                  <Tooltip
                    title={currentEducationYear.name + " eğitim yılına ait sözleşmelere girilen tahsilatların toplamı"}
                  >
                    <QuestionIcon sx={{ marginLeft: "5px", color: "gray", width: "20px", height: "auto" }} />
                  </Tooltip>
                </div>
              </TableCell>
              <TableCell>
                <div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                  <b>TOPLAM İADE</b>
                  <Tooltip
                    title={currentEducationYear.name + " eğitim yılına ait sözleşmelere girilen iadelerin toplamı"}
                  >
                    <QuestionIcon sx={{ marginLeft: "5px", color: "gray", width: "20px", height: "auto" }} />
                  </Tooltip>
                </div>
              </TableCell>
              <TableCell>
                <div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                  <b>TOPLAM GİDER</b>
                  <Tooltip
                    title={
                      <span style={{ whiteSpace: "pre-line" }}>
                        {`Sözleşmelerden bağımsız olarak ${currentEducationYear.yearStartDate} ve ${currentEducationYear.yearEndingDate} tarihleri arasında girilen giderlerin toplamı.

Bu tarihler hizmet dönemleri sekmesinde ${currentEducationYear.name} eğitim yılı için girilen başlangıç ve bitiş tarihlerine göre hesaplanır.`}
                      </span>
                    }
                    componentsProps={{
                      tooltip: {
                        sx: {
                          width: 650, // tam genişlik
                          maxWidth: 800, // en fazla genişlik
                          whiteSpace: "normal", // metni satır kırdırmaya izin verir
                        },
                      },
                    }}
                  >
                    <QuestionIcon sx={{ marginLeft: "5px", color: "gray", width: "20px", height: "auto" }} />
                  </Tooltip>
                </div>
              </TableCell>

              <TableCell>
                <div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                  <b>NET GELİR</b>
                  <Tooltip
                    title={
                      <span style={{ whiteSpace: "pre-line" }}>
                        {`Şu ana kadar ki net gelir durumu.
                        Tahsilatlardan, iadelerin ve giderlerin çıkarılması ile hesaplanır.
                        Sözleşmeler dikkate alınmaz.`}
                      </span>
                    }
                    componentsProps={{
                      tooltip: {
                        sx: {
                          width: 400, // tam genişlik
                          maxWidth: 800, // en fazla genişlik
                          whiteSpace: "normal", // metni satır kırdırmaya izin verir
                        },
                      },
                    }}
                  >
                    <QuestionIcon sx={{ marginLeft: "5px", color: "gray", width: "20px", height: "auto" }} />
                  </Tooltip>
                </div>
              </TableCell>
              <TableCell>
                <div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                  <b>KALAN TOPLAM ALACAK</b>
                  <Tooltip
                    title={
                      <span style={{ whiteSpace: "pre-line" }}>
                        {`Eğitim yılı için ileri tarihli kalan geliri gösterir.
                        Sözleşmeler toplamından, tahsilatlar toplamının çıkarılması ile hesaplanır.
                        İadeler ve giderler dikkate alınmaz.
                        `}
                      </span>
                    }
                    componentsProps={{
                      tooltip: {
                        sx: {
                          width: 450, // tam genişlik
                          maxWidth: 800, // en fazla genişlik
                          whiteSpace: "normal", // metni satır kırdırmaya izin verir
                        },
                      },
                    }}
                  >
                    <QuestionIcon sx={{ marginLeft: "5px", color: "gray", width: "20px", height: "auto" }} />
                  </Tooltip>
                </div>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
              <TableCell>{contractsAmount.toLocaleString()}</TableCell>

              <TableCell component="th" scope="row">
                {receiptsAmount.toLocaleString()}
              </TableCell>

              <TableCell component="th" scope="row">
                {withdrawsAmount.toLocaleString()}
              </TableCell>

              <TableCell component="th" scope="row">
                {expensesAmount.toLocaleString()}
              </TableCell>

              <TableCell component="th" scope="row">
                {(receiptsAmount - expensesAmount - withdrawsAmount).toLocaleString()}
              </TableCell>

              <TableCell>{(contractsAmount - receiptsAmount).toLocaleString()}</TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>

      <br />
      <br />
    </div>
  );
};

export default ReportsSummaryTable;
